module.exports = __webpack_public_path__ + "static/media/hrc-logo.455c4d3c.png";